<div class="noDataFound">

    <ng-container *ngIf="mode == 'page'">
       <div class="bb-no-data-found size-{{avatarSize}}" *ngIf="!!icon"></div>
         
        <berry-typo [name]="labelType" *ngIf="label" [weight]="labelWeight">{{label | translate}}</berry-typo>
        <berry-typo [name]="'body2'" *ngIf="body">{{body | translate}}</berry-typo>
        <div class=" radius_xs flex bg-primary" *ngIf="dropDownActions.length > 0">
            <berry-dropdown [typoName]="'body1'" [leftIcon]="'arrow_drop_down'" [title]="btnLabel" [typoWeight]="500" [actions]="dropDownActions" [text]="btnLabel" [icon]="'add'"
                            [buttonType]="'primary'" [typoColor]="'primary'" dataAutomationId="add"></berry-dropdown>
        </div>

    </ng-container>
    <ng-container *ngIf="mode == 'section'">
        
        <div class="noDataFound-sectionMode">
           <berry-icon [name]="iconSectinMode" [color]="'muted'" [isOutlined]="true" *ngIf="!!iconSectinMode"></berry-icon>
            <div class="noDataFound-sectionMode-end">

                <berry-typo [name]="labelType" *ngIf="label" [weight]="labelWeight">{{label | translate}}</berry-typo>
                <berry-typo [name]="'body2'" *ngIf="body">{{body | translate}}</berry-typo>

            </div>

        </div>
    
    </ng-container>

</div>
